import messages from './cmsContentLocale.json' with { type: 'json' };

export const cmsContentLocaleFi: Readonly<typeof messages> = messages;
